import { render, staticRenderFns } from "./ProjectsFilter.vue?vue&type=template&id=0a9f6242&scoped=true&"
import script from "./ProjectsFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsFilter.vue?vue&type=style&index=0&id=0a9f6242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f6242",
  null
  
)

export default component.exports